<template>
    <ModalComponent
        :name='"enlace-pago-plazo-" + plazo.id'
        title="Enviar enlace de pago"
        v-on:close="close"
    >
        <div class="row">
            <div class="col-12">
                <h5 class="m-0">Aquí podrá enviar un enlace por correo al usuario para que vaya a su perfil y pague su plazo fallido por valor de {{ plazo.importe | formatear_precio }}.</h5>
            </div>
            <div class="col-12 m-0 mt-3">
                <ContentOrLoading :class="loading ? 'p-5' : ''">
                    <Button @click="enviarPorCorreo()" v-if="!loading">Enviar</Button>
                </ContentOrLoading>
            </div>
        </div>
    </ModalComponent>
</template>

<script>
import ModalComponent from "@/components/backend/components/ModalComponent";

export default {
    props: ['plazo', 'params', 'url'],
    data() {
        return {
            mensaje: null,
            loading: false
        }
    },
    methods: {
        close() {
            this.$emit('close', 'enlace-pago-plazo-' + this.plazo.id);
        },
        enviarPorCorreo() {
            this.loading = true;

            const parametros = this.params;
            parametros.lista_id =  this.lista_id;
            parametros.plazo_id = this.plazo.id;
            
            this.$store.dispatch(this.config.getVuexAlias(this.url), parametros).then(res => {
                this.$toast.success('Correo enviado correctamente');
            }).catch(error => {
                this.$toast.error(error.response.data.message);
            }).finally(() => {
                this.close();
                this.loading = false;
            });
        },
    },
    computed: {
        lista_id() {
            return this.$store.getters.getListaId;
        }
    },
    components: {
        ModalComponent
    }
}
</script>